
import { defineComponent } from 'vue';
import LogoElem from "../pageElements/LogoElem.vue";

export default defineComponent({
    name: "ProjectMockup",

    components:{
        LogoElem
    },

    props:[
        "data"
    ],

    data(){
        return{
            desktopMockup: true,
            mockupChange: false,
            mockupImg: ""
        } 
    },

    mounted(){

        if (window.innerWidth <= 768){
            this.desktopMockup = false;
            this.mockupImg = this.data.mobileMockup;
        } else {
            this.mockupImg = this.data.desktopMockup;
        }

    },

    methods:{

        changeMockupImg(){

            // Set the mockup to the transition mode
            this.mockupChange = true;

            // Remove the transition mode
            setTimeout(() => {
                this.mockupChange = false;
            }, 750)

            // Change the mockup image
            setTimeout(() => {
                if (this.desktopMockup === true){
                    this.mockupImg = this.data.desktopMockup;
                } else {
                    this.mockupImg = this.data.mobileMockup;
                }
            }, 275);

        }

    },

    watch:{

        desktopMockup(){
            this.changeMockupImg();
        }

    }

});
